import { Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { HomeComponent } from './components/home/home.component';
export const routes: Routes = [
{ path: 'login', component: LoginComponent, title: 'Login'  },
{ path: '', redirectTo: 'login', pathMatch: 'full' },
{ path: 'home',           component: HomeComponent, data: { mask: 'user'      }, title: 'Home'  },
{ path: 'auth/user',      component: HomeComponent, data: { mask: 'user'      }, title: 'Auth user'  },
{ path: 'auth/group',     component: HomeComponent, data: { mask: 'group'     }, title: 'Auth group'  },
{ path: 'auth/role',      component: HomeComponent, data: { mask: 'role'      }, title: 'Auth role'  },
{ path: 'auth/right',     component: HomeComponent, data: { mask: 'right'     }, title: 'Auth right'  },
{ path: 'auth/usergroup', component: HomeComponent, data: { mask: 'usergroup' }, title: 'Auth user group'  },
{ path: 'auth/grouprole', component: HomeComponent, data: { mask: 'grouprole' }, title: 'Auth group role'  },
{ path: 'auth/roleright', component: HomeComponent, data: { mask: 'roleright' }, title: 'Auth role right'  },
{ path: 'track',          component: HomeComponent, data: { mask: 'track'     }, title: 'Track'  },
{ path: 'track/:id',      component: HomeComponent, data: { mask: 'track_one' }, title: 'Track'  },
{ path: 'race',           component: HomeComponent, data: { mask: 'race'      }, title: 'Race'  }

];
//export const routes: Routes = [];
